import React, { useEffect, useState } from "react";
import { HiMinus, HiOutlinePlus } from "react-icons/hi";
import styled from "styled-components";
import { useStateContext } from "../contexts/ContextProvider";

const CartItems = ({ cart, cartItems }) => {
  const { cartItem, setCartItem, getTotal, handleDelete } = useStateContext();
  const [select, setSelect] = useState(2);

  useEffect(() => {
    setSelect(cart.quantity);
    getTotal();
  }, [cartItem]);

  const handleQuantity = (productId, quantity) => {
    for (let product of cartItems) {
      if (product.prod_id === productId) {
        product.quantity = quantity;
      }
    }
    localStorage.setItem("cartitems", JSON.stringify(cartItems));
    setCartItem(cartItems);
    getTotal();
  };

  const decrement = () => {
    if (select >= 2) {
      setSelect(select - 1);
      handleQuantity(cart.prod_id, select - 1);
    } else {
      setSelect(1);
      handleQuantity(cart.prod_id, select);
    }
  };

  const increment = () => {
    setSelect(select + 1);
    handleQuantity(cart.prod_id, select + 1);
  };

  return (
    <Container>
      {/* Product Image */}
      <Image>
        <img src={cart.image} alt="" />
      </Image>

      <Info>
        {/* Product Description */}
        <p className="description">{cart.descr}</p>

        {/* Stock Availability */}
        <p
          style={{
            fontSize: "13px",
            marginTop: "1px",
            color: "#5c5c5c",
          }}
        >
          in stock
        </p>

        {/* Control Buttons */}
        <ControlButtons>
          {/* Quantity */}

          {/* <span>Qty</span>
            <select
              value={select}
              onChange={(e) => setSelect(e.target.value)}
              onClick={() => handleQuantity(cart.prod_id, select)}
            >
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
            </select> */}

          <IncrementButton>
            <button className="left" onClick={decrement}>
              <HiMinus />
            </button>
            <div>{select}</div>
            <button className="right" onClick={increment}>
              <HiOutlinePlus />
            </button>
          </IncrementButton>

          {/* Delete Button */}
          <p onClick={() => handleDelete(cart.prod_id)}>Delete</p>
        </ControlButtons>
      </Info>

      {/* Price */}
      <Price>
        <p>${cart.price}</p>
      </Price>
    </Container>
  );
};

export default CartItems;

const Container = styled.div`
  display: flex;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #a0a0a0;
`;

const Image = styled.div`
  width: 25%;
  img {
    object-fit: contain;
    height: 200px;
    width: 180px;
    @media (max-width: 430px) {
      height: 100px;
      width: 90px;
    }
  }
  @media (max-width: 470px) {
    width: 23%;
  }
`;

const Info = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  @media (max-width: 430px) {
    width: 50%;
    .description {
      font-size: 11px;
    }
  }
`;

const Price = styled.div`
  text-align: right;
  width: 15.1%;
  @media (max-width: 430px) {
    p {
      font-size: 14px;
      font-weight: 700;
    }
  }
`;

const Quantity = styled.div`
  display: flex;
  background-color: #ffffff;
  width: 61px;
  padding: 2px;
  border-radius: 5px;
  border: 1px solid #b9abb6;
  select {
    width: 34px;
    border: none;
    outline: none;
  }
`;

const ControlButtons = styled.div`
  display: flex;
  align-items: center;

  p {
    margin-left: 20px;
    padding-left: 14px;
    border-left: 1px solid #777676;
    font-size: 12px;
    color: #3a0325;
    cursor: pointer;
  }
`;

const IncrementButton = styled.div`
  display: flex;
  width: 100px;
  border: 1px solid #f1c1c1;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px;
  border-radius: 40px;
  transform: scale(0.8);

  button {
    outline: none;
    border: 1px solid #717171;
    color: #f8f2f2;
    :hover {
      transform: scale(1.07);
    }
    svg {
      @media (max-width: 470px) {
        transform: scale(1.09);
      }
    }
  }
  .left,
  .right {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #dc87d1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transform: scale(1.3);
    @media (max-width: 470px) {
      width: 20px;
      height: 20px;

      svg {
        font-weight: 700;
        transform: scale(1.7);
      }
    }
  }
  @media (max-width: 430px) {
    padding: 5px 5px;
  }
`;
